<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">Confirm Delete Lab</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to delete
            <strong>{{ lab?.lab_name }}</strong>?
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            This action cannot be undone.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose" :disabled="loading">
            Cancel
          </v-btn>
          <v-btn color="error" variant="flat" :loading="loading" @click="handleDelete">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { edit_lab_masters } from "@/graphql/mutations";
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export default {
  name: "DeleteLab",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    lab: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "deleted"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleDelete() {
      if (!this.lab?.lab_id && !this.lab?.id) return;

      this.loading = true;

      try {
        const input = {
          lab_id: this.lab.lab_id || this.lab.id,
          lab_status: "DEACTIVE",
          source: "BMS",
        };

        await client.graphql({
          query: edit_lab_masters,
          variables: {
            input,
          },
        });

        this.snackbar = {
          show: true,
          message: "Lab deleted successfully!",
          color: "success",
        };

        this.$emit("deleted");
        this.dialog = false;
      } catch (error) {
        this.snackbar = {
          show: true,
          message: error?.message || "Failed to delete lab",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
